import EventViewInfo from './EventViewInfo';

export default EventViewInfo;
